module.exports = __webpack_public_path__ + "static/media/texto_plano_portal.fe18bc57.png";